import React, { useEffect, useState } from 'react';
import { FieldValues, Path } from 'react-hook-form';
import RadioList, { FilterListItem } from '../../RadioList';
import { cameraService } from '../../../../services/central-api/cameras';

function DownloadCameraList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    const [search, setSearch] = useState('');
    const [items, setItems] = useState<FilterListItem<string>[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const minCharactersToSearch = 3;

    useEffect(() => {
        if (search.length < minCharactersToSearch) {
            setItems([]);
            setIsLoading(false);
            return;
        }

        let active = true;
        const timeout = setTimeout(async () => {
            try {
                setIsLoading(true);
                const cameras = await cameraService.getSimplifiedDownloadCameras(search);
                if (active) {
                    setItems(cameras.map(camera => ({ label: camera.title, value: camera.id })));
                }
            } catch (error) {
                console.error(error);
            } finally {
                if (active) {
                    setIsLoading(false);
                }
            }
        }, 1000);

        return () => {
            active = false;
            clearTimeout(timeout);
        };
    }, [search]);

    return <RadioList
        name={name}
        items={items}
        clearValue={null}
        onSearchTextChange={setSearch}
        isLoading={isLoading}
        minCharactersToSearch={minCharactersToSearch}
    />;
}

DownloadCameraList.getCount = (value: string | null) => value ? 1 : 0;

export default DownloadCameraList;
